/**
 * AsyncComponent
 * Code Splitting Component / Server Side Rendering
 */
import React from 'react';
import Loadable from 'react-loadable';
// rct page loader
import RctPageLoader from '../../components/RctPageLoader/RctPageLoader';

const Loading = (props) => {
    if (props.error) {
        console.error('props.error: ', props.error);
        return <div />;
    } else {
        return <RctPageLoader />;
    }
};

// suppliers list
const AsyncSuppliersListComponent = Loadable({
    loader: () => import('../../actionPages/suppliers/SuppliersList'),
    loading: Loading,
});

// tags list
const AsyncTagsListComponent = Loadable({
    loader: () => import('../../actionPages/tags/TagsList'),
    loading: Loading,
});

// documents list
const AsyncDocumentListComponent = Loadable({
    loader: () => import('../../actionPages/documents/DocumentsList.tsx'),
    loading: Loading,
});

// documents list
const AsyncUserDocumentListComponent = Loadable({
    loader: () => import('../../actionPages/documents/DocumentsList.tsx'),
    loading: Loading,
});

// documents edit
const AsyncDocumentEditComponent = Loadable({
    loader: () => import('../../actionPages/documents/DocumentEdit'),
    loading: Loading,
});

// UserProfile Profile
const AsyncUserProfileComponent = Loadable({
    loader: () => import('../../actionPages/profile'),
    loading: Loading,
});

// api keys
const AsyncApiKeysListComponent = Loadable({
    loader: () => import('../../actionPages/apiKeys/ApiKeysList'),
    loading: Loading,
});

// rules list
const AsyncRulesListComponent = Loadable({
    loader: () => import('../../actionPages/rules/RulesList.tsx'),
    loading: Loading,
});

// rules create
const AsyncRulesCreateComponent = Loadable({
    loader: () => import('../../actionPages/rules/RuleCreate.tsx'),
    loading: Loading,
});

// rules edit
const AsyncRulesEditComponent = Loadable({
    loader: () => import('../../actionPages/rules/RuleEdit.tsx'),
    loading: Loading,
});

// integrations
const AsyncIntegrationsListComponent = Loadable({
    loader: () => import('../../actionPages/integrations/IntegrationsList.tsx'),
    loading: Loading,
});

// export config list
const AsyncExportConfigListComponent = Loadable({
    loader: () => import('../../actionPages/configs/export/ExportConfigList.tsx'),
    loading: Loading,
});

// export config edit
const AsyncExportConfigEditComponent = Loadable({
    loader: () => import('../../actionPages/configs/export/ExportConfigEdit.tsx'),
    loading: Loading,
});

// export config create
const AsyncExportConfigCreateComponent = Loadable({
    loader: () => import('../../actionPages/configs/export/ExportConfigCreate.tsx'),
    loading: Loading,
});

// rules config list
const AsyncRulesConfigListComponent = Loadable({
    loader: () => import('../../actionPages/configs/rules/RulesConfigList.tsx'),
    loading: Loading,
});

// rules config edit
const AsyncRulesConfigEditComponent = Loadable({
    loader: () => import('../../actionPages/configs/rules/RulesConfigEdit.tsx'),
    loading: Loading,
});

// rules config create
const AsyncRulesConfigCreateComponent = Loadable({
    loader: () => import('../../actionPages/configs/rules/RulesConfigCreate.tsx'),
    loading: Loading,
});

const AsyncTemplatesListComponent = Loadable({
    loader: () => import('../../actionPages/templates/TemplatesList'),
    loading: Loading,
});

const AsyncTemplateCreateComponent = Loadable({
    loader: () => import('../../actionPages/templates/TemplateCreate'),
    loading: Loading,
});

const AsyncTemplateEditComponent = Loadable({
    loader: () => import('../../actionPages/templates/TemplateEdit'),
    loading: Loading,
});

// document type list
const AsyncDocumentTypeListComponent = Loadable({
    loader: () => import('../../actionPages/documentTypes/DocumentTypeList.tsx'),
    loading: Loading
});

// document type edit
const AsyncDocumentTypeEditComponent = Loadable({
    loader: () => import('../../actionPages/documentTypes/DocumentTypeEdit.tsx'),
    loading: Loading
});

// document type create
const AsyncDocumentTypeCreateComponent = Loadable({
    loader: () => import('../../actionPages/documentTypes/DocumentTypeCreate.tsx'),
    loading: Loading
});

// user type list
const AsyncUserListComponent = Loadable({
    loader: () => import('../../actionPages/users/UserList'),
    loading: Loading
});

// user edit
const AsyncUserEditComponent = Loadable({
    loader: () => import('../../actionPages/users/UserEdit.tsx'),
    loading: Loading
});

// user create
const AsyncUserCreateComponent = Loadable({
    loader: () => import('../../actionPages/users/UserCreate.tsx'),
    loading: Loading
});

// user history list
const AsyncUserHistoryListComponent = Loadable({
    loader: () => import('../../actionPages/userHistory/UserHistoryList.tsx'),
    loading: Loading
});

// user history show
const AsyncUserHistoryShowComponent = Loadable({
    loader: () => import('../../actionPages/userHistory/UserHistoryShow.tsx'),
    loading: Loading
});

// requests list
const AsyncRequestsListComponent = Loadable({
    loader: () => import('../../actionPages/requests/RequestList.tsx'),
    loading: Loading
});

// template collections list
const AsyncTemplateCollectionsListComponent = Loadable({
    loader: () => import('../../actionPages/templateCollections/TemplateCollectionsList.tsx'),
    loading: Loading,
});

// UserProfile Profile
const AsyncUserPlanComponent = Loadable({
    loader: () => import('../../actionPages/plan'),
    loading: Loading,
});

export {
    AsyncTemplatesListComponent,
    AsyncTemplateCreateComponent,
    AsyncTemplateEditComponent,

    AsyncApiKeysListComponent,

    AsyncDocumentListComponent,
    AsyncUserDocumentListComponent,
    AsyncDocumentEditComponent,

    AsyncUserProfileComponent,

    AsyncTagsListComponent,

    AsyncSuppliersListComponent,

    AsyncRulesListComponent,
    AsyncRulesCreateComponent,
    AsyncRulesEditComponent,
    AsyncRulesConfigCreateComponent,
    AsyncRulesConfigEditComponent,
    AsyncRulesConfigListComponent,

    AsyncIntegrationsListComponent,

    AsyncExportConfigListComponent,
    AsyncExportConfigCreateComponent,
    AsyncExportConfigEditComponent,

    AsyncDocumentTypeListComponent,
    AsyncDocumentTypeEditComponent,
    AsyncDocumentTypeCreateComponent,

    AsyncUserListComponent,
    AsyncUserEditComponent,
    AsyncUserCreateComponent,

    AsyncUserHistoryListComponent,
    AsyncUserHistoryShowComponent,

    AsyncRequestsListComponent,
    AsyncTemplateCollectionsListComponent,
    AsyncUserPlanComponent
};
